export default __webpack_public_path__ + "static/frog-8c5fed0c7f3b9188ca5570be6ccbbde8.png";